export enum UserInfoCombinationType {
  Name = "name",
  NameAndOrganization = "nameAndOrganization",
  NameAndJobTitleAndOrganization = "nameAndjobTitleAndOrganization"
}

export enum TextAlign {
  LEFT = "LEFT",
  CENTER = "CENTER",
  RIGHT = "RIGHT"
}

// do not remove or change values
// caution: db migration is required if any value is removed or changed
export enum FontFamilyToUrlMapping {
  defaultFontStyle = "https://fonts.googleapis.com/css2?family=Roboto:wght@400;500;700&display=swap",
  style1 = "https://fonts.googleapis.com/css2?family=Comic+Neue:ital,wght@0,300;0,400;0,700;1,300;1,400;1,700&display=swap",
  style2 = "https://fonts.googleapis.com/css2?family=Quicksand:wght@300..700&display=swap",
  style3 = "https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,100;0,300;0,400;0,500;0,700;0,900;1,100;1,300;1,400;1,500;1,700;1,900&display=swap",
  style4 = "https://fonts.googleapis.com/css2?family=Poppins:wght@400;500;600;700&display=swap",
  style5 = "https://fonts.googleapis.com/css2?family=Anybody:wght@400;500;600;700&display=swap",
  style6 = "https://fonts.googleapis.com/css2?family=Open+Sans:ital,wght@0,300..800;1,300..800&display=swap",
  style7 = "https://fonts.googleapis.com/css2?family=Raleway:ital,wght@0,100..900;1,100..900&display=swap",
  style8 = "https://fonts.googleapis.com/css2?family=Red+Hat+Display:ital,wght@0,300..900;1,300..900&display=swap",
  style9 = "https://fonts.googleapis.com/css2?family=Lora:ital,wght@0,400..700;1,400..700&display=swap",
  style10 = "https://fonts.googleapis.com/css2?family=Comfortaa:wght@300..700&display=swap",
  style11 = "https://fonts.googleapis.com/css2?family=Merriweather:ital,wght@0,300;0,400;0,700;0,900;1,300;1,400;1,700;1,900&display=swap",
  style12 = "https://fonts.googleapis.com/css2?family=Play:wght@400;700&display=swap",
  style13 = "https://fonts.googleapis.com/css2?family=Philosopher:ital,wght@0,400;0,700;1,400;1,700&display=swap",
  style14 = "https://fonts.googleapis.com/css2?family=Exo:ital,wght@0,100..900;1,100..900&display=swap",
  style15 = "https://fonts.googleapis.com/css2?family=Expletus+Sans:ital,wght@0,400..700;1,400..700&display=swap",
  style16 = "https://fonts.googleapis.com/css2?family=Kalnia:wght@400..700&display=swap"
}
